import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['price', 'quantity', 'taxRate', 'totalPrice', 'sellPrice', 'sellQuantity', 'sellTotalPrice', 'profit'];

  connect() {
    this.updateTotal();
  }

  updateTotal() {
    this.totalPriceTarget.textContent = this.priceWithCommna(this.totalPrice());

    if (this.hasSellPriceTarget) {
      this.sellTotalPriceTarget.textContent = this.priceWithCommna(this.sellTotalPrice());
      this.profitTarget.textContent = this.priceWithCommna(this.sellTotalPrice() - this.totalPrice());
    }

    event = this.dispatch('updated');
  }

  totalPrice() {
    // NOTE: 円未満はサーバ側の計算（.to_i = ゼロ方向切り捨て）に合わせて trunc する
    //       （Math.floor はマイナス単価の値引き行でサーバと1円ずれる）。
    //       税率もサーバと同じ「× (100 + 税率) ÷ 100」の順で計算する（× 1.1 の形は浮動小数点誤差で境界の1円がずれ得る）
    const price = this.priceTarget.value * this.quantityTarget.value;
    if (this.hasTaxRateTarget) {
      return Math.trunc((price * (100 + Number(this.taxRateTarget.value))) / 100);
    }
    return Math.trunc(price);
  }

  sellTotalPrice() {
    return Math.trunc(this.sellPriceTarget.value * this.sellQuantityTarget.value);
  }

  priceWithCommna(price) {
    const isNegative = price < 0;
    const absPrice = Math.abs(price);
    const formattedPrice = absPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return isNegative ? `-${formattedPrice}` : formattedPrice;
  }
}
